// Prevent multiple means selection due to multiple forms presence on paymeny
// means page
function handlePaymentMeansInputs() {
  const inputs = document.querySelectorAll('input[name="payment-mode"]')
  for (const input of inputs) {
    input.checked = false
  }

  function uncheckInputs(id) {
    for (const input of inputs) {
      input.checked = input.id === id
      // Also display form details
      const detail = input
        .closest('.c-form__block')
        ?.querySelector('.c-form__details')
      if (!detail) continue

      if (input.id !== id) {
        detail.classList.add('visually-hidden')
      } else {
        detail.classList.remove('visually-hidden')
      }
    }
  }

  for (const input of inputs) {
    input.addEventListener('click', () => uncheckInputs(input.id))
  }
}

handlePaymentMeansInputs()
